export function getFirma(firma) {
    return { type: 'GET_FIRMA', firma };
}
